import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import storePromise from "@/store";

import Admin from "../views/Admin.vue";
import Election from "../views/Election.vue";
import Login from "../views/Login.vue";
import Trustee from "../views/Trustee.vue";
import Vote from "../views/Vote.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    name: "Admin",
    path: "/admin",
    component: Admin,
  },
  {
    name: "Election",
    path: "/admin/:uuid",
    component: Election,
    props: true,
  },
  {
    name: "Login",
    path: "/login",
    component: Login,
    props: true,
  },
  {
    name: "Vote",
    path: "/vote/:uuid",
    component: Vote,
    props: true,
  },
  {
    name: "Trustee",
    path: "/trustee/:uuid/:email",
    component: Trustee,
    props: true,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const store = await storePromise;
  const state = store.state;
  if (!state.email || !state.password) {
    if (to.name !== "Login" && to.name !== "Trustee" && to.name !== "Vote")
      next({ name: "Login" });
    else next();
  } else {
    if (state.elections === null || state.administrators === null)
      try {
        if (state.administrators === null)
          await store.dispatch("loadAdministrators");
        if (state.elections === null) await store.dispatch("loadElectionNames");
      } catch (e) {
        router.push({ name: "Login" });
      }
    next();
  }
});

export default router;
